import OrganizationProxyLinkCreate from './OrganizationProxyLinkCreate'
import OrganizationProxyLinkEdit from './OrganizationProxyLinkEdit'

export default {
  create: OrganizationProxyLinkCreate,
  edit: OrganizationProxyLinkEdit,
}
